// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1oO62","text":"SelectPayment_text__EQDq1","title":"SelectPayment_title__5d5zE","btn":"SelectPayment_btn__2uRxX"};